// ─── Login Route ───

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginPage } from '../features/auth/LoginPage';

const loginSearchSchema = z.object({
  error: z.string().optional(),
  // NP-P65a: deep-link destination to restore after sign-in. Treated as an
  // untrusted, same-origin-only relative path — see `safeReturnTo` in
  // `features/auth/safeReturnTo.ts` for the open-redirect guard applied
  // wherever this value is consumed.
  returnTo: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  component: LoginPage,
});
